import type { ConstValues } from '@openx/types/helpers.ts';
import type { TFunction } from 'i18next';
import type { OpenXAgentToolConfig } from './types.ts';

export const TAIL_SIZE = 8;

export const OPENX_AGENT_TOOL = {
  DEAL_PROMPT: 'dealPrompt',
  TARGETING_EXPLAINER: 'targetingExplainer',
  TROUBLESHOOTER: 'troubleshooter',
} as const;
export type OpenXAgentTool = ConstValues<typeof OPENX_AGENT_TOOL>;

export const getOpenXAgentTools = (t: TFunction): OpenXAgentToolConfig[] => [
  {
    id: OPENX_AGENT_TOOL.DEAL_PROMPT,
    title: t('Deal Prompt'),
    description: t('Create new deals and structure tailored audience segments from scratch.'),
    cta: t('Start with Deal Prompt'),
  },
  {
    id: OPENX_AGENT_TOOL.TARGETING_EXPLAINER,
    title: t('Check Targeting'),
    description: t('Decode targeting parameters into buyer personas.'),
    cta: t('Start with Targeting Check'),
  },
  {
    id: OPENX_AGENT_TOOL.TROUBLESHOOTER,
    title: t('Troubleshooter'),
    description: t('Detect delivery blockers and fix setup errors in real time.'),
    cta: t('Start with Troubleshooter'),
  },
];
